import React from 'react';
import PropTypes from 'prop-types';

const Option = ({ display_name: displayName, image_url: imageUrl }) => (
  <div>
    {imageUrl && <img src={imageUrl} alt={displayName} width={26} height={26} style={{ marginRight: '8px' }} />}
    <span style={{ fontWeight: 500 }}>{displayName}</span>
  </div>
);

Option.propTypes = {
  display_name: PropTypes.string.isRequired,
  image_url: PropTypes.string,
};

Option.defaultProps = {
  image_url: undefined,
};

export default Option;
